import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import type { ILogoCloudGridProps } from "./LogoCloudGrid.props";

export const LogoCloudGrid = ({ items }: ILogoCloudGridProps) => {
  const Link = getComponent("Link");
  return (
    <div className="grid grid-cols-2 border-l border-t border-parchment/20 md:grid-cols-4">
      {items.map((item, index) => {
        const logo = (
          <VelvetMedia
            className="h-32 border-b border-r border-parchment/20 bg-transparent p-7"
            imageClassName="object-contain grayscale transition-[filter] duration-200 group-hover:grayscale-0"
            media={item.logo}
            sizes="180px"
          />
        );
        return (
          <div
            className={cn(
              "transition-colors duration-200 hover:bg-thread/10",
              index % 2 === 0 ? "md:-translate-y-3" : "md:translate-y-3",
            )}
            key={index}
          >
            {item.logoLink ? (
              <Link
                aria-label={item.logoLink.accessibilityLabel || undefined}
                className="group block focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
                href={item.logoLink.href}
                rel={item.logoLink.openInNewTab ? "noopener noreferrer" : undefined}
                target={item.logoLink.openInNewTab ? "_blank" : undefined}
              >
                {logo}
              </Link>
            ) : (
              logo
            )}
          </div>
        );
      })}
    </div>
  );
};

LogoCloudGrid.displayName = "Content::LogoCloudGrid";
